import { ArrowRightCircleIcon, InformationCircleIcon, MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { PencilIcon, TrashIcon, UserMinusIcon, UserPlusIcon, WindowIcon } from '@heroicons/react/24/solid';
import {
  Card,
  CardHeader,
  Input,
  Typography,
  Button,
  CardBody,
  Chip,
  CardFooter,
  Tabs,
  TabsHeader,
  Tab,
  Avatar,
  IconButton,
  Tooltip,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
  Select,
  Option,
} from '@material-tailwind/react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { listUserIDAll, listUserIDAllCount, updateUserID } from '../../../services/apiUsers';
import axios from 'axios';

import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import L from 'leaflet';
import images from '../../../assets/images';
import { convertNumberToWords } from '../../../utils/helper';
import { permissionLabel } from '../../../utils/permissions';

const TABS = [
  {
    label: 'Tất Cả',
    value: '',
  },
  {
    label: 'Hoạt_Động',
    value: 1,
  },
  {
    label: 'Đã_Nghỉ',
    value: 2,
  },
];

const TABLE_HEAD = [
  'Tài khoản',
  'Họ tên',
  'Số điện thoại',
  'Trạng thái',
  'Lần Cuối Login',
  'Ngày tạo',
  'Vị trí',
  'Tác vụ',
];

const customIcon = new L.Icon({
  iconUrl: images.avt,
  shadowUrl: markerShadow,
  iconSize: [41, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
  className: 'w-10 h-10 rounded-full border-4 border-white shadow-lg overflow-hidden',
});

export default function DsUsers() {
  const [resultListUsers, setResultListUsers] = useState([]);
  const [page, setPage] = useState(1);
  const [countUser, setCountUser] = useState(0);
  const [objBoLoc, setObjBoLoc] = useState({ status: '1', username: '' });
  const [address, setAddress] = useState({});
  const [error, setError] = useState('');
  const [openDetail, setOpenDetail] = useState(false);
  const [openEditXemSo, setOpenEditXemSo] = useState(false);

  const [formData, setFormData] = useState({
    viewsdt: '',
    viewso: '',
    viewkhoanggia: '',
    viewnoso: '0', // 0 = cho xem sổ, 1 = không cho xem sổ
  });

  const handleOpen = () => setOpenDetail(!openDetail);
  const handleOpenEditXemSo = () => setOpenEditXemSo(!openEditXemSo);

  const listUserAll = async (isstatus = '', username = '', pages = 1) => {
    const resultUserAll = await listUserIDAll(isstatus, username, pages);
    if (resultUserAll.length > 0) {
      setResultListUsers(resultUserAll);
      const countUser = await listUserIDAllCount(isstatus, username);
      setCountUser(countUser.totalRows);
    } else {
      setResultListUsers([]);
    }
  };
  const getIdQuyenXemSdtSo = (data) => {
    // console.log(data);
    setFormData({
      id: data.id,
      viewsdt: data.viewsdt,
      viewso: data.viewso,
      viewkhoanggia: data.viewkhoanggia,
      viewnoso: data.viewnoso,
    });
  };

  useEffect(() => {
    listUserAll(1);
    document.title = 'Danh sách nhân viên';
  }, []);

  const handleEnterKey = (e) => {
    if (e.key === 'Enter') {
      listUserAll(objBoLoc.status, objBoLoc.username, 1);
    }
  };

  const nextPage = () => {
    const total = Math.ceil(countUser / 50);
    if (total > page) {
      setPage(page + 1);
      listUserAll(objBoLoc.status, objBoLoc.username, page + 1);
    }
  };

  const prevPage = () => {
    const total = Math.ceil(countUser / 50);
    if (total <= page && page > 1) {
      setPage(page - 1);
      listUserAll(objBoLoc.status, objBoLoc.username, page - 1);
    }
  };

  const alertRemoveUser = async (id, status) => {
    if (
      window.confirm(status === 1 ? `Bạn đã chắc chắn NGỪNG HOẠT ĐỘNG USER` : `Bạn muốn cho USER HOẠT ĐỘNG chở lại`)
    ) {
      // Save it!
      const body = {
        id: id,
        data: { status: status === 1 ? 2 : 1 },
      };
      const resultAPISIM = await updateUserID(body);
      if (resultAPISIM?.message === 'OK') {
        listUserAll(objBoLoc.status, objBoLoc.username, 1);
      }
    } else {
      // Do nothing!
      console.log('Hủy yêu cầu');
    }
  };

  const openUser = async (id, username) => {
    if (window.confirm(`Bạn muốn mở khóa cho tài khoản ${username}`)) {
      // Save it!
      const body = {
        id: id,
        data: { numberlogin: 0 },
      };
      const resultAPISIM = await updateUserID(body);
      if (resultAPISIM?.message === 'OK') {
        listUserAll(objBoLoc.status, objBoLoc.username, 1);
      }
    } else {
      // Do nothing!
      console.log('Hủy yêu cầu');
    }
  };

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const getAddress = async (toado, username, latdate) => {
    setAddress({});
    setError('');
    if (toado) {
      const point = JSON.parse(toado);
      try {
        const response = await axios.get(
          `https://nominatim.openstreetmap.org/reverse?format=json&lat=${point.latitude}&lon=${point.longitude}`,
        );
        if (response.data && response.data.display_name) {
          setAddress({
            name: username,
            latdatelogin: latdate,
            address: response.data.display_name,
            lat: response.data.lat,
            lon: response.data.lon,
          });
          setError('');
        } else {
          setError('Không tìm thấy địa chỉ');
        }
      } catch (err) {
        setError('Lỗi khi lấy dữ liệu');
      }
    } else {
      setError('Chưa có dữ liệu vị trí');
    }
  };

  const subEditXemSo = async () => {
    const body = {
      id: formData.id,
      data: formData,
    };
    const resultAPISIM = await updateUserID(body);
    if (resultAPISIM?.message === 'OK') {
      listUserAll(objBoLoc.status, objBoLoc.username, 1);
      handleOpenEditXemSo();
      alert('Cập nhật thành công');
    }
  };
  return (
    <div>
      {/* SỬA QUYỀN XEM SĐT - SỔ */}
      <Dialog open={openEditXemSo} handler={handleOpenEditXemSo}>
        <DialogHeader className="font-[UTM-Avo]">CHỈNH SỬA QUYỀN XEM SĐT - SỔ</DialogHeader>
        <DialogBody className="font-[500]">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            <Input
              value={formData.viewsdt}
              label="Số lượt xem sđt"
              placeholder="Nhập số lượt xem sđt"
              required
              onChange={(e) => handleChange('viewsdt', e.target.value)}
            />

            <Input
              value={formData.viewso}
              label="Số lượt xem sổ"
              placeholder="Nhập số lượt xem sổ"
              required
              onChange={(e) => handleChange('viewso', e.target.value)}
            />

            <>
              <Input
                value={formData.viewkhoanggia}
                label="Khoảng giá xem sđt tối đa"
                placeholder="Nhập giá được xem sđt tối đa"
                required
                onChange={(e) => handleChange('viewkhoanggia', e.target.value)}
                icon={
                  <div className="text-nowrap ml-[-30px] text-red-500">
                    {convertNumberToWords(formData.viewkhoanggia)}
                  </div>
                }
              />
            </>

            <div>
              <Select
                label="Không cho xem sổ"
                value={formData.viewnoso}
                onChange={(value) => handleChange('viewnoso', value)}
              >
                <Option value="0">Cho xem sổ</Option>
                <Option value="1">Không cho xem sổ</Option>
              </Select>
            </div>
          </div>
        </DialogBody>

        <DialogFooter>
          <Button variant="filled" color="green" size="sm" onClick={subEditXemSo} className="mr-1">
            <span>Lưu Cập Nhật</span>
          </Button>
          <Button variant="outlined" size="sm" color="red" onClick={handleOpenEditXemSo} className="mr-1">
            <span>Đóng</span>
          </Button>
        </DialogFooter>
      </Dialog>

      <Dialog open={openDetail} handler={handleOpen}>
        <DialogHeader className="font-[UTM-Avo]">
          {error ? error : address.name ? `Vị trí đăng nhập của ${address.name}` : 'Đang tải dữ liệu...'}
          {/* <br /> <span className="text-red-500 size-[10px]">{error}</span> */}
        </DialogHeader>

        <DialogBody className="overflow-scroll leading-8 font-[500]">
          {address.name ? (
            <div className="text-gray-900 font-[UTM-Avo] ">
              <div>
                Thời gian lần cuối Login:
                <b className="text-orange-500"> {address.latdatelogin}</b>
              </div>
              <div>
                Đ/c tại:
                <b> {address.address}</b>
              </div>

              <MapContainer center={[address.lat, address.lon]} zoom={15} style={{ height: '500px', width: '100%' }}>
                <TileLayer
                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <Marker position={[address.lat, address.lon]} icon={customIcon}>
                  <Popup>{address.name}</Popup>
                </Marker>
              </MapContainer>
            </div>
          ) : (
            ''
          )}
        </DialogBody>
        <DialogFooter>
          <Button variant="text" color="red" onClick={handleOpen} className="mr-1">
            <span>Đóng</span>
          </Button>
        </DialogFooter>
      </Dialog>

      <Card className="w-full">
        <CardHeader floated={false} shadow={false} className="rounded-none">
          <div className="mb-8 flex items-center justify-between gap-8">
            <div>
              <div className="text-xl font-bold">DANH SÁCH NHÂN VIÊN</div>
              {/* <Typography color="gray" className="mt-1 font-normal">
              Tất cả nhân viên đang hoạt động và đã nghỉ
            </Typography> */}
            </div>
            <div className="flex shrink-0 flex-col gap-2 sm:flex-row">
              {/* <Button variant="outlined" size="sm">
              view all
            </Button> */}
              <Link to="/users">
                <Button className="flex items-center gap-3 bg-amber-900" size="sm">
                  <UserPlusIcon strokeWidth={2} className="h-4 w-4" /> Thêm Nhân Viên Mới
                </Button>
              </Link>
            </div>
          </div>
          <div className="flex flex-col items-center justify-between gap-4 md:flex-row">
            <Tabs value={1} className="w-full md:w-max">
              <TabsHeader>
                {TABS.map(({ label, value }) => (
                  <Tab
                    key={value}
                    value={value}
                    onClick={() => {
                      listUserAll(value, objBoLoc.username, 1);
                      setObjBoLoc({ ...objBoLoc, status: value });
                    }}
                  >
                    &nbsp;&nbsp;{label}&nbsp;&nbsp;
                  </Tab>
                ))}
              </TabsHeader>
            </Tabs>
            <div className="w-full md:w-80">
              <Input
                label="Tìm kiếm theo tài khoản"
                value={objBoLoc?.username}
                icon={<MagnifyingGlassIcon className="h-5 w-5" />}
                onChange={(e) => setObjBoLoc({ ...objBoLoc, username: e.target.value })}
                onKeyPress={handleEnterKey}
              />
              <Typography variant="small" color="gray" className="mt-2 flex items-center gap-1 font-normal">
                <InformationCircleIcon className="h-4 w-4" />
                Nhập tài khoản tìm kiếm và sau đó ấn enter
              </Typography>
            </div>
          </div>
        </CardHeader>
        <CardBody className="overflow-auto px-0">
          <table className="mt-4 w-full min-w-max table-auto text-left">
            <thead>
              <tr>
                {TABLE_HEAD.map((head) => (
                  <th key={head} className="border-y border-blue-gray-100 bg-blue-gray-50/50 p-4">
                    <Typography variant="small" color="blue-gray" className="font-normal leading-none opacity-70">
                      {head}
                    </Typography>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {resultListUsers.map((row, index) => {
                const isLast = index === resultListUsers.length - 1;
                const classes = isLast ? 'p-4' : 'p-4 border-b border-blue-gray-50';

                return (
                  <tr key={index}>
                    <td className={classes}>
                      <div className="flex items-center gap-3">
                        <div className="flex flex-col">
                          <label className="font-normal text-base">
                            <b>{row.username}</b>
                          </label>
                          <label className="font-normal text-sm opacity-70">{row.email}</label>
                        </div>
                      </div>
                    </td>
                    <td className={classes}>
                      <div className="flex flex-col">
                        <label className="font-normal text-base">{row.name}</label>
                        <label className="font-normal text-sm opacity-70">
                          ({permissionLabel(row)})
                        </label>
                      </div>
                    </td>

                    <td className={classes}>
                      <label className="font-normal text-base">{row.phone}</label>
                    </td>
                    <td className={classes}>
                      <div className="w-max">
                        <Chip
                          variant="ghost"
                          size="sm"
                          value={row.numberlogin >= 5 ? 'Đã bị khóa' : row.status === 1 ? 'Hoạt động' : 'Đã nghỉ'}
                          color={row.numberlogin >= 5 ? 'red' : row.status === 1 ? 'green' : 'blue-gray'}
                        />
                      </div>
                    </td>

                    <td className={classes}>
                      <label className="font-normal text-base">{row?.lastdatelogin}</label>
                    </td>
                    <td className={classes}>
                      <label className="font-normal text-base">{row?.create_date}</label>
                    </td>
                    <td className={classes}>
                      <IconButton
                        variant="filled"
                        color="blue"
                        onClick={() => {
                          getAddress(row.toado, row.username, row?.lastdatelogin);
                          handleOpen();
                        }}
                      >
                        Xem
                      </IconButton>
                    </td>
                    <td className={classes}>
                      {row.numberlogin >= 5 && (
                        <Tooltip content="Mở Khóa tài khoản">
                          <IconButton variant="filled" color="green" onClick={() => openUser(row.id, row.username)}>
                            MỞ KHÓA
                          </IconButton>
                        </Tooltip>
                      )}
                      <Tooltip content="Sửa Lượt Xem Sổ - SĐT">
                        <IconButton
                          variant="text"
                          onClick={() => {
                            handleOpenEditXemSo();
                            getIdQuyenXemSdtSo(row);
                          }}
                        >
                          <WindowIcon className="h-4 w-4 text-purple-500" />
                        </IconButton>
                      </Tooltip>

                      <Tooltip content="Sửa User">
                        <Link to={`/users?u=${row.id}`}>
                          <IconButton variant="text">
                            <PencilIcon className="h-4 w-4" />
                          </IconButton>
                        </Link>
                      </Tooltip>

                      <Tooltip content={`${row.status === 1 ? 'Ngưng hoạt động' : 'Hoạt động lại'}`}>
                        <IconButton variant="text" onClick={() => alertRemoveUser(row.id, row.status)}>
                          <UserMinusIcon
                            className={`h-4 w-4 ${row.status === 1 ? 'text-red-500' : 'text-green-500'}`}
                          />
                        </IconButton>
                      </Tooltip>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </CardBody>
        {Math.ceil(countUser / 50) > page && (
          <CardFooter className="flex items-center justify-between border-t border-blue-gray-50 p-4">
            <Typography variant="small" color="blue-gray" className="font-normal">
              Page {page} of {Math.ceil(countUser / 50)}
            </Typography>
            <div className="flex gap-2">
              <Button variant="outlined" size="sm" onClick={prevPage}>
                Trang Trước
              </Button>
              <Button variant="outlined" size="sm" onClick={nextPage}>
                Trang Tiếp
              </Button>
            </div>
          </CardFooter>
        )}
      </Card>
    </div>
  );
}
